import React from 'react';
import {
  Paper, Stepper, Step, StepLabel
} from '@mui/material';

const AppStepper = ({ activeStep }) => {
  return (
    <Paper 
      elevation={0}
      sx={{ 
        mb: 2, 
        p: { xs: 2, md: 3 }, 
        borderRadius: 3,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04)'
      }}
    >
      <Stepper activeStep={activeStep}>
        <Step key="Docs Mapping">
          <StepLabel>Docs Mapping</StepLabel>
        </Step>
        <Step key="Crawler Info">
          <StepLabel>Crawler Info</StepLabel>
        </Step>
      </Stepper>
    </Paper>
  );
};

export default AppStepper; 